import { render, staticRenderFns } from "./AdvertisersList.vue?vue&type=template&id=019a22a2&"
import script from "./AdvertisersList.vue?vue&type=script&lang=ts&"
export * from "./AdvertisersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports